<template>
  <div class="qrcode Kanit" style="overflow: hidden">
    <v-toolbar dark class="toolbarqrcode"  style="margin-top: 10px;">
      <img :src="BASE_URL + 'static/icon/user.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title v-if="typeCompany==='owner'">สร้าง Account สำหรับ {{(typeCompanys === 'owner')? 'หน่วยงานในเครือสภากาชาด':'หน่วยงานร่วมโครงการ'}} </v-toolbar-title>
      <v-toolbar-title v-else-if="typeCompany==='partner'">สร้าง Account สำหรับ หน่วยงานตนเอง </v-toolbar-title>
    </v-toolbar>
    <div class="horizontal-center widthdivstep">
      <!-- Success Message -->
      <v-card v-if="showSuccess" color="grey lighten-2" class="mb-12 pd-10" style="margin-top: 20px;">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon type="button" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="generate_id" v-on="on">
              <v-icon style="color: #5f5f5f; font-size: 16px !important;">file_copy</v-icon>
            </v-btn>
          </template>
          <span>Copy Generate ID</span>
        </v-tooltip>

        <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><b>Generate ID:</b> {{generate_id}}</p>

        <p style="text-align: left; margin-bottom: 0; margin-top: 20px;">
          <span style="color: red !important;">*</span> สามารถดูข้อมูลที่ทำการสร้างได้จากส่วนของ Report/ข้อมูล admin โดยค้นหาจาก Generate ID หรือ
          <span @click="gotodetail" style="color: #a80d00; text-decoration: underline; font-weight: 800;cursor: pointer;">กดที่นี่</span> เพื่อแสดงข้อมูล
        </p>

        <v-btn rounded color="primary" style="color: white; margin-top: 20px;" @click="successAccount()">สร้าง Account ใหม่</v-btn>
      </v-card>

      <!-- Form -->
      <v-card v-else color="grey lighten-2" class="ma-4 pa-4 mb-6 form-card-fixed" style="margin-top: 20px;">
        <!-- ข้อมูลหน่วยงาน -->
        <div class="section-title">ข้อมูลหน่วยงาน</div>

        <v-row no-gutters>
          <v-col cols="12" sm="6" md="6">
            <p id="company" style="text-align: left; margin-bottom: 0;" v-if="typeCompany == 'owner'">หน่วยงานเจ้าของ Account <span style="color: red !important;">*</span></p>
            <v-select
              v-if="typeCompany == 'owner'"
              :items="itemsCompanyOwnerBytype"
              item-text="company_name"
              item-value="company_id"
              v-model="CompanyOwner"
              label="เลือกหน่วยงานเจ้าของ Account"
              outlined
              hide-details
              single-line
              class="Kanit mr-2"
              attach
              dense
              :menu-props="{ bottom: true, offsetY: true }"
              background-color="#fafafa"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <p style="text-align: left; margin-bottom: 0;">ประเภท Account <span style="color: red !important;">*</span></p>
            <v-select
              :items="listRoleAccount"
              v-model="role"
              label="ประเภทบัญชี"
              outlined
              hide-details
              single-line
              class="Kanit "
              attach
              dense
              :menu-props="{ bottom: true, offsetY: true }"
              background-color="#fafafa"
            ></v-select>
          </v-col>
        </v-row>

        <v-divider style="margin: 20px 0;"></v-divider>

        <!-- รายละเอียด -->
        <div class="section-title">รายละเอียด</div>

        <div class="form-content-scrollable">
          <v-radio-group v-model="radioTypeInfo" style="margin-top: 2px;">
            <v-radio :key="1" :value="1" label="กำหนดเอง (1 บัญชี)" color="#aa0800ff"></v-radio>

            <v-row no-gutters v-if="radioTypeInfo == 1" style="padding-left: 0px; padding-right: 0px; margin-top: 10px;">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="ชื่อ"
                  single-line
                  outlined
                  hide-details
                  v-model="first_name"
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  background-color="#fafafa"
                  dense
                >
                  <template v-slot:append v-if="first_name != ''">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="นามสกุล"
                  single-line
                  outlined
                  hide-details
                  v-model="last_name"
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  background-color="#fafafa"
                  dense
                >
                  <template v-slot:append v-if="last_name != ''">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="อีเมล"
                  single-line
                  outlined
                  hide-details
                  v-model="email"
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  :rules="emailRules"
                  background-color="#fafafa"
                  dense
                >
                  <template v-slot:append v-if="checkEmail()">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
                    </v-fade-transition>
                  </template>
                  <template v-slot:append v-else-if="email != ''">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #dc0303; font-size: 20px;">fas fa-times-circle</v-icon>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="หมายเลขโทรศัพท์"
                  single-line
                  outlined
                  hide-details
                  v-model="phone"
                  mask="###-###-####"
                  :rules="phoneRules"
                  required
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  background-color="#fafafa"
                  dense
                >
                  <template v-slot:append v-if="checkPhone()">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #069206; font-size: 20px;">fas fa-check-circle</v-icon>
                    </v-fade-transition>
                  </template>
                  <template v-slot:append v-else-if="phone != ''">
                    <v-fade-transition leave-absolute>
                      <v-icon style="color: #dc0303; font-size: 20px;">fas fa-times-circle</v-icon>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="ชื่อผู้ใช้งาน"
                  single-line
                  outlined
                  v-model="username"
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  :hide-details="checkusername()"
                  :rules="usernameRules"
                  background-color="#fafafa"
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="รหัสผ่าน"
                  single-line
                  outlined
                  v-model="password"
                  type="password"
                  class="textfieldInput mx-1"
                  style="margin-bottom: 10px;"
                  :hide-details="checkpassword()"
                  :rules="passwordRules"
                  background-color="#fafafa"
                  dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="ยืนยันรหัสผ่าน"
                  single-line
                  outlined
                  :hide-details="checkrepassword()"
                  :rules="repasswordRules"
                  v-model="repassword"
                  class="textfieldInput mx-1"
                  type="password"
                  style="margin-bottom: 10px;"
                  background-color="#fafafa"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-radio :key="2" :value="2" label="ระบบสร้างให้ (หลายบัญชี)" color="#aa0800ff"></v-radio>

            <div v-if="radioTypeInfo == 2" style="padding-left: 0px; padding-right: 0px; margin-top: 10px;">
              <v-text-field
                label="จำนวนบัญชีที่ต้องการสร้าง"
                single-line
                outlined
                hide-details
                v-model="NumAccount"
                type="number"
                min="1"
                background-color="#fafafa"
                dense
              ></v-text-field>
            </div>
          </v-radio-group>
        </div>

        <v-divider style="margin: 10px 0;"></v-divider>

        <v-card-actions style="text-align: center; justify-content: center;">
          <!-- Submit Button -->
          <div>
            <v-btn
              rounded
              color="primary"
              style="color: white;"
              @click="CreateAccount()"
              v-if="radioTypeInfo == 2"
              :disabled="!canSubmit()"
            >
              สร้าง Account
            </v-btn>
            <v-btn
              rounded
              color="primary"
              style="color: white;"
              @click="CreateAccount()"
              :disabled="checkNext()"
              v-else
            >
              สร้าง Account
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
Vue.component(VueQrcode.name, VueQrcode)

export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      radioTypeInfo: 0,
      showSuccess: false,
      CompanyOwner: '',
      SerialNum: '',
      itemsCompany: [],
      itemsCompanyOwner: [],
      listRoleAccount: ['admin','superadmin'],
      role: '',
      NumAccount: 1,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      username: '',
      password: '',
      repassword: '',
      itemsCompanyOwnerBytype: [],
      generatedAccount: [],
      generate_id: '',
      typeCompany: '',
      typeCompanys: '',
      phoneRules: [
        v => (!!v && v.length === 10) || 'กรุณาใส่เบอร์โทรศัพท์ของคุณจำนวน 10 หลัก',
        v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
        v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
      ],
      emailRules: [
        v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
      ],
      usernameRules: [
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว'
      ],
      passwordRules: [
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว'
      ]
    }
  },
  created () {
    this.typeCompany = this.$store.state.key_object.typeCompany
    this.CompanyOwner = this.$store.state.key_object.idCompany
    // this.nameCompany = this.authen.nameCompany
    this.typeCompanys = this.$route.query.type
    if (this.typeCompanys !== 'owner' && this.typeCompanys !== 'partner') {
      this.$router.push('/homepage')
    }
    this.getCompanyOwner()
  },
  watch: {
    NumAccount () {
      if (this.NumAccount > 1000) {
        this.NumAccount = 1000
        this.$swal( 'ไม่สำเร็จ', 'ไม่ควรเกิน 1000', 'error' )
      }
    },
    '$route.query.type' () {
      // console.log(this.$route.query.type)
      this.typeCompanys = this.$route.query.type
      if (this.typeCompanys !== 'owner' && this.typeCompanys !== 'partner') {
        this.$router.push('/homepage')
      }
      this.successAccount()
      if (this.typeCompanys == 'owner') {
        this.CompanyOwner = this.authen.idCompany
      }
      this.getCompanyOwner()
    }
  },
  computed: {
    // itemsCompanyOwnerBytype () {
    //   // return this.itemsCompanyOwner
    //   return this.itemsCompanyOwner.filter(post => {
    //         return post.company_type.toLowerCase().includes(this.typeCompanys.toLowerCase())})
    // }
    repasswordRules() {
      return (this.password === this.repassword) || ['รหัสผ่านไม่ตรงกัน']
    }
  },
  methods: {
    gotodetail () {
      this.$router.push('/information_admin?id=' + this.generate_id)
    },
    checkNext () {
     if (this.first_name != '' && this.last_name != ''  && this.email != '' && this.phone != '' && this.username != '' && this.password != '' && this.repassword == this.password) {

      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email) && /^0[0-9]{9}$/.test(this.phone)) {
        return false
      } else {
        return true
      }
     } else {
      return true
     }
    },
    checkusername () {
      if (this.username == '') {
        return false
      } else if ((this.username !='' && this.username.length < 6)){
        return false
      // } else if (!/^([^A-Z])+$/.test(this.username)){
      //   return false
      // } else if (!/^([a-z])+$/.test(this.username) && !/^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(this.username)){
      //   return false
      } else {
        return true
      }
    },
    // checkusername () {
    //   // if ((this.username !='' && this.username.length < 6) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(this.username)){
    //   //   return false
    //   // } else {
    //   //   return true
    //   // }

    // },
    checkrepassword () {
      if ((this.repassword !='' && this.repassword.length < 6) || this.repassword !== this.password){
        return false
      } else {
        return true
      }
    },
    checkpassword () {
      if (this.password !='' && this.password.length < 6){
        return false
      } else {
        return true
      }
    },
    checkEmail () {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    },
    checkPhone () {
      return /^0[0-9]{9}$/.test(this.phone)
    },
    canSubmit () {
      if (this.CompanyOwner == '' || this.role == '' || this.radioTypeInfo == 0) {
        return false
      }
      if (this.radioTypeInfo == 2 && this.NumAccount >= 1) {
        return true
      }
      return false
    },
    successAccount () {
      this.showSuccess = false
      this.radioTypeInfo = 0
      this.CompanyOwner = ''
      this.NumAccount = 1
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.phone = ''
      this.username = ''
      this.password = ''
      this.repassword = ''
      this.role = ''
      this.generatedAccount = []
      this.generate_id = ''
    },
    CreateAccount () {
      this.$swal({
        title: 'ยืนยันการสร้าง Account?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true,
        customClass: {
          popup: 'custom-swal-font'
        }
      }).then((result) => {
        if (result.value) {
          if (this.radioTypeInfo == 1) {
            var body = {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              phone: this.phone,
              username: this.username,
              password: this.password,
              company_id: this.CompanyOwner,
              role: this.role
            }
            this.$api.createAdminByInfo(body).then((response) => {
              if (response.data.message === 'success') {
                this.$swal( 'สำเร็จ', 'สร้างบัญชีสำเร็จแล้ว', 'success' )
                this.generatedAccount = [response.data.data]
                this.generate_id = response.data.data.generate_id
                this.showSuccess = true
              } else if (response.data.message === 'username_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'username ซ้ำกับในระบบ', 'error' )
              } else if (response.data.message === 'phone_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'หมายเลขโทรศัพท์นี้ถูกลงทะเบียนในระบบแล้ว', 'error' )
              }
            })
          } else if (this.radioTypeInfo == 2) {
            var body = {
              number_account_create: this.NumAccount,
              company_id: this.CompanyOwner,
              role: this.role
            }
            this.$api.createAdminBySystemGenerate(body).then((response) => {
              // console.log(response.data.data)
              if (response.data.message === 'success') {
                this.$swal( 'สำเร็จ', 'สร้างบัญชีสำเร็จแล้ว', 'success' )
                this.generatedAccount = response.data.data
                this.generate_id = response.data.data[0].generate_id
                this.showSuccess = true
              }
            })
          }
        }
      })
    },
    getCompanyMaintenance () {
      this.$api.getCompanyMaintenance().then((response) => {
        this.itemsCompany = response.data.data
      })
    },
    getCompanyOwner () {
      this.$api.getCompanyOwner().then((response) => {
        this.itemsCompanyOwner = response.data.data
        this.itemsCompanyOwnerBytype = this.itemsCompanyOwner.filter(post => {return post.company_type.toLowerCase().includes(this.typeCompanys.toLowerCase())})
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
>>>.v-menu__content .v-list-item__title {
  font-size: 16px !important;
  font-weight: normal !important;
  line-height: 34px !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
>>>.v-input--selection-controls .v-radio>.v-label {
  color: black;
  }
.pd-10 {
  padding: 10px !important;
}
.pd-20 {
  /* padding: 20px !important; */
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #a80e00;
  margin-bottom: 15px;
  text-align: left;
}
.form-card-fixed {
  min-height: 500px;
  max-height: 500px;
  display: flex;
  flex-direction: column;
}
.form-content-scrollable {
  overflow-y: auto;
  max-height: 280px;
  flex: 1;
  padding-right: 5px;
}
.form-content-scrollable::-webkit-scrollbar {
  width: 8px;
}
.form-content-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.form-content-scrollable::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.form-content-scrollable::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.toolbarqrcode {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}

.widthdivstep {
    width: 55vw;
    margin-top: 10px;
  }

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .widthdivstep {
    width: 86vw;
    margin-top: 10px;
  }
  
}


/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/



/*@media screen and (max-width: 900px) and (min-width: 600px), (min-width: 1100px) {
  .widthdivstep {
    width: 50vw;
    margin-top: 10px;
  }
}*/
</style>



// WEBPACK FOOTER //
// src/components/create/create_account.vue